import {useSelector} from 'react-redux'
import {InitialStateType} from '@/store/reducers'
import {Outlet} from 'react-router-dom'
import React from 'react'
import NotFoundPage from '@/components/pages/NotFoundPage/NotFoundPage'

const SecuredRoute = () => {
    const {type} = useSelector((state: InitialStateType) => state.user)
    
    if(type === 'guest') {
        return <NotFoundPage/>
    }
    
    return <Outlet/>
}

export default SecuredRoute